/**
 * The operator-facing reason a cash collection was refused. Cash is taken only
 * within the Point's open Shift, and only by that Shift's operator (ADR-0035):
 * the server refuses with `PRECONDITION_FAILED` when none is open and with
 * `FORBIDDEN` when it is someone else's, and the counter says so plainly.
 */
export function collectFailureKey(
	error: unknown,
): 'payment.noOpenShift' | 'payment.notShiftOperator' | 'payment.collectFailed' {
	const code = (error as { data?: { code?: string } } | null)?.data?.code
	if (code === 'PRECONDITION_FAILED') return 'payment.noOpenShift'
	if (code === 'FORBIDDEN') return 'payment.notShiftOperator'
	return 'payment.collectFailed'
}
